import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import icWhatsapp from "assets/images/whatsapp.png"
import icArrowUp from "assets/images/icons/arrow-up.svg"
import ApiGet from "api/ApiGet";
import { useTranslation } from 'react-i18next';



const Whatsapp = () => {
    let navigate = useNavigate()
    const [isHover, setIsHover] = useState(false)
    const [hoverPosition, setHoverPosition] = useState("")
    const [visible, setVisible] = useState(false)
    const [fiturWA, setFiturWA] = useState([])

    const { t, i18n } = useTranslation(); // Mengakses fungsi terjemahan


    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
            setHoverPosition("scrolled")
        }
        else if (scrolled <= 300) {
            setVisible(false)
            setHoverPosition("")
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    useEffect(() => {
        ApiGet.actions.Whatsapp()
        .then((response) => {
            let url = response.responseResult
            // console.log(url, '-------------')
            // let url="/images/fd9703169fa3c5062bc92971f-otto-(3).png"
            setFiturWA(url)
            // setImgPopUp(`${uAPI}${url.image}`)
            //return image = `${uAPI}${url.image}`
            //console.log(setImgPopUp, '-------------')
            // if (responseResult(response)) {
            //     setData(responseResult(response))
            // }
        })

        window.addEventListener('scroll', toggleVisible);
        return () => {
            window.removeEventListener('scroll', toggleVisible)
        }
    }, [])

    // console.log("fiturWA ",fiturWA)
    return (
        (fiturWA?.status === 1 ? <>
            {
                isHover && (
                    <div className={`whatsapp-text ${hoverPosition}`}>
                        <b>Halo!</b> {t('whatsapp1')}
                        <br />
                        Klik {t('disini')}
                    </div>
                )
            }

            <div className={`whatsapp ${hoverPosition}`}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                onClick={() => {
                    window.open(`https://api.whatsapp.com/send?phone=${fiturWA.phone_number}&#038;text=Hi%PSL%2C%20saya%20ingin%20bertanya%20tentang%20servis%20logistik`, "_self")
                }}
            >
                <img src={icWhatsapp} alt="whatsapp" />
            </div>

            {
                visible && (
                    <div className="back-to-top bg-white rounded-lg px-4 py-2 flex flex-row" onClick={scrollToTop}>
                        <div className="text-primary text-[15px] mr-[10px]">Back To Top</div>
                        <img src={icArrowUp} alt="arrow-up" />
                    </div>
                )
            }

        </> : <></>)
        
    )
}

export default Whatsapp